<template>
  <div>
    <v-card
      elevation="1"
      color="#FFF"
    >
      <v-card-title>
        <p class="process-header">
          Purpose Of Visit
        </p>
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-textarea
            v-model="visitPurpose"
            dense
            :rules="[(v) => !!v || 'This field is required']"
            filled
            color="#000000"
            class="field-text-style"
            light
            outlined
            label="Visit Purpose*"
            background-color="transparent"
          />
        </v-form>
      </v-card-text>
    </v-card>
    <v-btn
      color="#000"
      class="mt-5 btn-style"
      elevation="0"
      @click="gatherVisitPurpose()"
    >
      Next
    </v-btn>
    <v-btn
      light
      color="#E6E6E6"
      class="mt-3 btn-style"
      elevation="0"
      @click="cancel()"
    >
      Cancel
    </v-btn>
    <centre-spinner
      :loading="loading"
    />
  </div>
</template>

<script>
import spinner from 'src/views/components/SpinnerCentre';
import Constants from 'src/constants';
export default {
  name: 'VisitPurpose',
  components: {
    'centre-spinner': spinner,
  },
  data: () => ({
    visitPurpose: '',
    valid: false,
    loading: false,
  }),
  computed: {
    userDetails () {
      return this.$store.getters.getUser;
    },
    locationName () {
      return this.$store.getters['swiftuser/getLocationName'];
    },
  },
  methods: {
    gatherVisitPurpose () {
      if (this.$refs.form.validate() === false) {
        this.$store.dispatch('alert/onAlert', {
          message: 'Please fill the required fields before proceeding',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        return;
      }
      this.loading = true;
      this.$store.dispatch('swiftuser/saveVisitPurpose', {
        visit_purpose: this.visitPurpose,
      });
      this.loading = false;
      this.$emit('visit-purpose-stored');
    },
    cancel () {
      this.loading = true;
      localStorage.removeItem('siteId');
      localStorage.removeItem('scannedTime');
      setTimeout(() => {
        this.$router.push({ name: 'CheckIn' });
      }, 1000);
    },
  },
};
</script>

<style scoped>
#title-text{
  font-weight: bold;
}
</style>
